import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import { IReferral } from "@/referrals/referral";

const DealSizeCol = (): ColumnDef<IReferral> => ({
  header: "Deal size",
  accessorKey: "deal_size",
  cell: ({ row }) => formatMoney(row.original.deal_size) || "-",
  size: 120,
});

export default DealSizeCol;
